import { ListChecks } from "lucide-react";
import {
  KpiWatchlistParamsSchema,
  defaultKpiWatchlistParams,
  type KpiWatchlistParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { KpiWatchlistWidget } from "./Component.js";
import { KpiWatchlistEditor } from "./Editor.js";
import type { KpiWatchlistView } from "./types.js";

/**
 * KPI Watchlist — dashboard data widget. Up to six pinned KPIs as a signal feed.
 * `TParams` = saved `{ kpiIds }`; `TView` = the resolved `{ kpis: KpiDef[] }`.
 */
export const kpiWatchlistDef: SqlWidgetDef<
  KpiWatchlistParams,
  KpiWatchlistView
> = {
  kind: "kpiWatchlist",
  label: "KPI Watchlist",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 480, h: 320 },
  defaultParams: defaultKpiWatchlistParams,
  Component: KpiWatchlistWidget,
  storage: "sql",
  schema: KpiWatchlistParamsSchema,
  accent: "cyan",
  icon: ListChecks,
  subtitle: "Cross-plant signals",
  defaultRoster: false,
  category: "single",
  layout: { col: 1, row: 1, width: 480, height: 320 },
  dashboard: {
    icon: ListChecks,
    defaultWidth: "wide",
    category: "Operations",
    supportsTitleOverride: true,
    EditorForm: KpiWatchlistEditor,
  },
};

registerWidget(kpiWatchlistDef);
